import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../../app.reducer';
import {IClient} from '../../../shared/interfaces/IClient';
import {SessionService} from '../../../core/services/session.service';
import {Router} from '@angular/router';


@Component({
  selector: 'app-sidebar-header',
  templateUrl: './sidebar-header.component.html',
  styleUrls: ['./sidebar-header.component.css']
})
export class SidebarHeaderComponent implements OnInit {
  menuState = false;
  user: IClient;

  constructor(private store: Store<AppState>, private sessionService: SessionService, private router: Router) { }

  ngOnInit(): void {
    this.store.select('core').subscribe(res => {
      this.user = res.user;
    });
  }

  logout() {
    this.sessionService.removeToken().then(_ => {
      this.router.navigateByUrl('/auth/login');
    })
  }

}
